import React, {useLayoutEffect, useState} from 'react';
import {Button, Icon}                     from '@sirius/ui-lib/src/blocks/Controls';
import {HBox, VBox}                       from '@sirius/ui-lib/src/blocks/Layout';
import {SubjectIcon}                      from '@sirius/ui-lib/src/blocks/Controls/SubjectIcon/SubjectIcon';
import {Subject}                          from '@sirius/ui-lib/src/blocks/Controls/SubjectIcon/iconComponents/types';
import subjectIcons                       from '@sirius/ui-lib/src/blocks/Controls/SubjectIcon/iconComponents/name-list.json';
import {block}                            from '../block';
import {
    UiSchemaEntry,
    DataCellType,
    ColumnCellType,
    IconDataWidgetList,
    IconDataWidget
}                                         from '../@types';

const DataCell:React.FC<DataCellType> = ({row, column}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [list, setList]             = useState<IconDataWidget[]>(row[column.name]?.list);

    const data      = row[column.name] as IconDataWidgetList;
    const hasExpand =
        !!data?.list?.length &&
        !!data?.lengthConstraint &&
        data.list.length > data.lengthConstraint
    ;

    useLayoutEffect(
        () => {
            if (!!data?.list?.length) {
                const currentList =
                    !isExpanded &&
                    !!data?.lengthConstraint &&
                    data.list.length > data.lengthConstraint
                        ? data.list.slice(0, data.lengthConstraint)
                        : data.list
                ;

                setList(currentList);
            }
        },
        [isExpanded, JSON.stringify(data)]
    );

    const toggleExpanded = () =>
        setIsExpanded(prev => !prev)
    ;

    return (
        <VBox className = {block.el('datacell-icon-text-list')}>
            {
                !!list?.length
                    ? list.map(
                        ({icon, data}, i) =>
                            <HBox key       = {`${column.name}-${i}`}
                                  className = {block.el('datacell-icon-text-list-item')}
                            >
                                {
                                    row[column.name].icon in subjectIcons
                                        ? <SubjectIcon subject   = {icon as Subject}
                                                       className = {block.el('datacell-name-icon')}
                                                       mode      = {'colored'}
                                                       size      = {'s'}
                                        />
                                        : <Icon size      = {'s'}
                                                icon      = {icon}
                                                className = {block.el('datacell-name-icon')}
                                        />
                                }
                                <span className={block.el('datacell-name') + block.el('datacell-icon-text-list-item-label')}>
                                    {data || ''}
                                </span>
                            </HBox>
                    )
                    : null
            }
            {
                hasExpand &&
                <Button className = {block.el('datacell-icon-text-list-expand-button')}
                        onAction  = {toggleExpanded}
                        size      = 'xxs'
                        icon      = {isExpanded ? 'expand_less' : 'expand_more'}
                        mode      = 'text'
                />
            }
        </VBox>
    );
};

const ColumnCell:React.FC<ColumnCellType> = ({column}) =>
    <span className={block.el('cell-title')}>
        {column.title || column.name}
    </span>
;

const IconDataListCell: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {IconDataListCell};
